module.exports = __webpack_public_path__ + "img/HU22353605.adf9fde3.png";